import PropTypes from 'prop-types';

export default {
    // challenge id to be passed to ToggleButton
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // image to be displayed in challenge row
    thumbnail: PropTypes.string,
    // The name of the challenge to be displayed in row
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // The name of the challenge to display in banner
    title: PropTypes.string,
    // The name of the challenge type to be displayed in row e.g Global
    badge: PropTypes.string,
    // The description of the challenge type to be displayed in row
    description: PropTypes.string,
    // The number of litter pieces picked up so far
    pickups: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // The target number of litter pieces for this challenge
    target: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // The target number of litter pieces for this challenge
    progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // The start date for the challenge to be displayed in row
    startDate: PropTypes.string,
    // The create date for the challenge
    createDate: PropTypes.string,
    // The end date for the challenge to be displayed in row
    endDate: PropTypes.string,
    // function to be called when toggle button is changed
    onToggle: PropTypes.func,
    // bool representing the state of the toggle
    toggleState: PropTypes.bool,
    // name of user who created the challenge
    createdBy: PropTypes.string,
    // thumbnail image of user who created the challenge
    creatorThumbnail: PropTypes.string,
};
